
import { VatDeclarationQuarterPeriod } from "@/utils/vat-delcaration/quarter-period";
import { v4 } from "uuid";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			uid: v4(),
			period: new VatDeclarationQuarterPeriod()
		};
	},
	props: {
		show: Boolean
	},
	computed: {
		quarters():string[]{
			return ["1", "2", "3", "4"];
		}
	},
	watch: {
		show: {
			immediate: true,
			handler(){
				if (!this.show) return;
				this.$emit("input", this.period);
			}
		}
	},
	methods: {
		setQuarter(i:string){
			this.period.ForQuarter = parseInt(i);
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
